import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/modules/shared/_services/api.service';
import { ENDPOINTS } from 'src/app/_configs/endpoints';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})

export class TenderService {

  constructor(private apiService: ApiService, private router: Router) { }

  tenderindexing(tenderBy: any) {
    let url = `${environment.TENDER.API_BASE_URL}${ENDPOINTS.TENDER.TENDER_KEYWORDS + '?type=' + tenderBy}`;
    return this.apiService.get(url)
  }

  tenderStats() {
    let url = `${environment.TENDER.API_BASE_URL}${ENDPOINTS.TENDER.TENDER_STATS}`;
    return this.apiService.get(url)
  }

  search(searchData: any) {
    let url = `${environment.TENDER.API_BASE_URL}${ENDPOINTS.TENDER.SEARCH + '?query=' + searchData}`;
    return this.apiService.get(url)
  }

  cityList(stateId: any) {
    let url = `${environment.TENDER.API_BASE_URL}${ENDPOINTS.TENDER.CMS.RETRIEVE_CITY_LIST + '?stateId=' + stateId}`;
    return this.apiService.get(url)
  }

  // old code

  retrieveTenderListing(req: any) {
    let url = `${environment.TENDER.API_BASE_URL}${ENDPOINTS.TENDER.RETRIEVE_TENDERS_LISTING}`
    return this.apiService.post(url, req)
  }

  // retrieveTenderDetails(tenderId: any) {
  //   let url = `${environment.TENDER.API_BASE_URL}${ENDPOINTS.TENDER.RETRIEVE_TENDER_DETAILS}${tenderId}`
  //   return this.apiService.get(url).pipe(catchError(error => {
  //     console.error('Error retrieving tenders by state:', error);
  //     this.router.navigate(["page-not-found"])
  //     return [];
  //   }));
  // }

  retrieveTenderDetails(tenderId: any, stateId: any, authorityId: any) {
    let url = `${environment.TENDER.API_BASE_URL}${ENDPOINTS.TENDER.RETRIEVE_TENDER_DETAILS}${tenderId}/${stateId}/${authorityId}`
    return this.apiService.get(url).pipe(catchError(error => {
      console.error('Error retrieving tenders by state:', error);
      this.router.navigate(["page-not-found"])
      return [];
    }));
  }
}
